import React, { useState, useEffect, useContext } from 'react'
import { types } from '../types.js'
import { BrManageMenuButton } from '@bloomreach/react-sdk'
import DOMPurify from 'dompurify'
import {
  getLinkUrl,
  getLocalPath,
  getCurrentPath,
  GlobalContext,
  getKeyPage,
  isLocal,
  isCms,
  getUrlParameter,
  isProduct,
  getSiteName,
  isExperienceManager,
} from '../../utility'
import {
  isInstitutional,
  isInvestor,
} from '../../../global/authentication/authentication-manager.js'
import { Link2 } from '../link/link.jsx'
import { BreadCrumbs as BlogBreadCrumbs } from '../blog/breadCrumbs/BreadCrumbs.jsx'
import { getFundContentData } from '../../../components/FundDetails/Data/FundDetailsDataSource.js'

const isBlogUrl = (pathName) => {
  return (
    pathName.startsWith('/cti-cms/experience-manager/cti-blogspa-preview') ||
    pathName.startsWith('/cti-site/blogspa') ||
    pathName.startsWith('/blogspa') ||
    pathName.startsWith('/insights/latest-insights') ||
    pathName.startsWith('/insights/market-perspectives') ||
    pathName.startsWith('/cti-site/cti-institutional/insights/latest-insights') ||
    pathName.startsWith('/institutional/insights/latest-insights')
  )
}
export const Metamenu = ({ page, component }) => {
  const searchParamId = getUrlParameter('id')
  const [menu, setMenu] = useState(null)
  const [breadcrumbs, setBreadcrumbs] = useState([])
  const { document, setBreadcrumbsGlobal } = useContext(GlobalContext)
  const localPath = getLocalPath()
  const isBlog = isBlogUrl(window.location.pathname)

  useEffect(() => {
    modifyBreadcrumbs()
  }, [page, component, document])

  const modifyBreadcrumbs = async () => {
    const _menuRef = component?.getModels().menu
    const _menu = _menuRef && page?.getContent(_menuRef)
    if (_menu) {
      setMenu(_menu)

      if (searchParamId && !document) {
        return
      }

      let currentUrl = getCurrentPath()
      const siteName = getSiteName()

      if (siteName === 'cti-advisor-spa') {
        currentUrl = '/insights' + currentUrl
      } else if (siteName === 'cti-blogspa') {
        currentUrl = '/insights/latest-insights' + currentUrl
      } else if (
        siteName === 'cti-advisorspa' &&
        !currentUrl.startsWith('/about') &&
        !currentUrl.startsWith('/resources') &&
        !currentUrl.startsWith('/investment-products') &&
        !currentUrl.startsWith('/investment-capabilities')
      ) {
        currentUrl = '/about' + currentUrl
      }

      const menuItems = _menu?.getItems()

      const _breadcrumbs = getBreadcrumbs(currentUrl, menuItems)

      let hasDocument = false

      if (
        currentUrl.startsWith('/investment-products') &&
        (currentUrl?.endsWith('/historical-data') ||
          currentUrl?.endsWith('/details') ||
          currentUrl?.endsWith('/full-holdings'))
      ) {
        const cusip = getUrlParameter('cusip')
        const fund = await getFundContentData(cusip)
        _breadcrumbs.breadcrumbs.push({
          name: fund.fundName,
          url: null,
        })
      }

      if (currentUrl?.endsWith('/cart-order')) {
        _breadcrumbs.breadcrumbs.push({
          name: 'Cart Order',
          url: null,
        })
      }
      if (currentUrl?.endsWith('/fund-information-statements')) {
        _breadcrumbs.breadcrumbs.push({
          name: 'Fund Information Statements',
          url: null,
        })
      }

      if (
        searchParamId &&
        document?.payload?.title &&
        document?.href === window.location.href
      ) {
        if (isProduct()) {
          // TODO: Find the URL for "category page" dynamically instead of hardcode
          const keyPage = getKeyPage(document.payload.keys)

          if (keyPage) {
            _breadcrumbs.breadcrumbs.push(keyPage)
          }
        }

        _breadcrumbs.breadcrumbs.push({
          name: document.payload.title,
          url: null,
        })

        hasDocument = true
      }

      if (_breadcrumbs.breadcrumbs?.length > 1) {
        setBreadcrumbs(_breadcrumbs.breadcrumbs)
      } else {
        setBreadcrumbs([])
      }

      if (
        (!searchParamId || hasDocument) &&
        siteName !== 'cti-blogspa' &&
        !(
          siteName === 'cti-institutional' &&
          currentUrl.startsWith('/insights/latest-insights')
        )
      ) {
        setBreadcrumbsGlobal(_breadcrumbs.breadcrumbs)
      }
    }
  }

  const getUrlNoChannel = (url) => {
    if (url) {
      const _url = url.split('/')

      if (_url[1] === 'investor') {
        _url.splice(1, 1)
        return _url.join('/')
      }
    }

    return url
  }

  const getBreadcrumbs = (currentUrl, items, info) => {
    if (!info) {
      info = { found: false, breadcrumbs: [] }
    }

    items.forEach((item) => {
      if (info.found) {
        return
      }

      const _url = getUrlNoChannel(item.getUrl()?.split('?')[0])

      // Don't add breadcrumb for Home (e.g. '/')
      if (_url && _url !== '/' && currentUrl.indexOf(_url) > -1) {
        info.breadcrumbs.push({
          name: item.getName(),
          // DEV NOTE: For some insane reason, parameters on a parent are also on the children, so we set the value to match the item's 'hst:referencesitemapitem'
          url:
            _url === currentUrl ||
            item.getParameters()?.unlinked ===
              (item?.model?.properties['hst:referencesitemapitem'] ||
                item?.model?.properties['hst:externallink'])
              ? null
              : item.getUrl(),
          isExternal: item?.model?.properties['hst:externallink'],
        })
      }

      if (_url === currentUrl) {
        info.found = true

        return
      }

      const children = item.getChildren()

      if (children.length > 0) {
        info = getBreadcrumbs(currentUrl, children, info)
      }
    })

    return info
  }

  const homeLink = () => {
    let link = '/'

    if (isInstitutional()) {
      link = '/institutional'
    } else if (isInvestor()) {
      link = '/investor'
    }

    return (
      <>
        <div>
          <a
            className="u-textSizeMsrm1 u-textColorBrandLight"
            href={DOMPurify.sanitize(link)}
          >
            Home
          </a>
        </div>
        <img
          src={`${
            isLocal() || isCms() ? '/cti-site' : ''
          }/webfiles/latest/assets/cti/images/icon_chevron_brand.svg`}
          alt=""
        />
      </>
    )
  }

  return (
    menu && (
      <div className="Breadcrumbs u-bgColorLight">
        {<BrManageMenuButton menu={menu} />}
        {isExperienceManager(page) && (
          <div className="u-sizeConstrained u-flex u-flexAlignItemsBaseline u-flexJustifyBetween u-sizeFull">
            {menu?.getItems().map((item, index) => {
              return (
                <div key={index} className="u-flex u-flexAlignItemsCenter">
                  <MenuLink item={item} page={page} />
                </div>
              )
            })}
          </div>
        )}
        {isBlog ? (
          <BlogBreadCrumbs page={page} menu={menu} />
        ) : (
          breadcrumbs &&
          breadcrumbs.length > 0 && (
            <div className="u-bgColorWhite">
              <div className="u-sizeConstrained u-flex u-flexAlignItemsCenter">
                <div className="u-flex u-flexAlignItemsCenter u-sizeFull u-borderTop u-paddingVert3gu">
                  {homeLink()}
                  {breadcrumbs.map((breadcrumb, index) => (
                    <React.Fragment key={index}>
                      {index > 0 && (
                        <img
                          src={`${
                            isLocal() || isCms() ? '/cti-site' : ''
                          }/webfiles/latest/assets/cti/images/icon_chevron_brand.svg`}
                          alt=""
                        />
                      )}
                      <div>
                        {breadcrumb.url ? (
                          <a
                            className="u-textSizeMsrm1 u-textColorBrandLight"
                            href={DOMPurify.sanitize(
                              (localPath === '/advisor' ||
                              (breadcrumb.isExternal === breadcrumb.url &&
                                localPath === '/investorspa')
                                ? ''
                                : localPath === '/investorspa'
                                  ? '/investor'
                                  : localPath) +
                                breadcrumb.url?.replace(localPath, '')
                            )}
                          >
                            {breadcrumb.name}
                          </a>
                        ) : (
                          <div className="u-textSizeMsrm1 u-textColorDefault">
                            {breadcrumb.name}
                          </div>
                        )}
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    )
  )
}
Metamenu.propTypes = {
  ...types,
}
const MenuLink = ({ item, page }) => {
  // console.log('ITEM >>>', item)

  const name = item.getName()
  // const type = item.getLink()?.type
  const url = item.getUrl()?.split('?')[0]
  const modifiedUrl = getLinkUrl(item.getLink())

  // console.log('NAME >>>', name)
  // console.log('URL >>>', url)
  // console.log('TYPE >>>', type)

  const path = getCurrentPath()

  const isSelected =
    path === url ||
    (url?.length > 1 &&
      (path === url || (!!item?.getChildren().length && path.startsWith(url))))

  return (
    <div className="u-posRelative u-paddingLeft2gu u-paddingRight2gu u-paddingVert1gu">
      {
        <div className="u-flex u-flexCol">
          <Link2
            url={modifiedUrl}
            text={name}
            className={`u-textNoWrap u-textColorLight ${
              isSelected ? 'u-textBold' : ''
            } u-textSizeMsrm2`}
          />
        </div>
      }
      {item?.getChildren() && item?.getChildren().length ? (
        <div className="u-paddingVert1gu u-paddingHoriz0">
          {item?.getChildren().map((item, index) => (
            <div key={index} className="u-textColorLight">
              <MenuLink item={item} page={page} />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  )
}
MenuLink.propTypes = {
  item: types.component,
  page: types.page,
}
